module.exports = __webpack_public_path__ + "static/media/bg.3206c247.svg";